import type { NoteFormValues } from "@/features/projects/project/internalNotes/types";

function getDraftKey(requestId: number, userId: number): string {
  return `internal-notes-draft:${requestId}:${userId}`;
}

export function readNoteDraft(
  requestId: number,
  userId: number | undefined,
): NoteFormValues | null {
  if (!userId) return null;

  try {
    const raw = localStorage.getItem(getDraftKey(requestId, userId));

    if (!raw) return null;

    return JSON.parse(raw) as NoteFormValues;
  } catch {
    return null;
  }
}

export function writeNoteDraft(
  requestId: number,
  userId: number | undefined,
  values: NoteFormValues,
): void {
  if (!userId) return;

  try {
    if (!values.name && !values.description) {
      localStorage.removeItem(getDraftKey(requestId, userId));

      return;
    }

    localStorage.setItem(
      getDraftKey(requestId, userId),
      JSON.stringify(values),
    );
  } catch {
    // localStorage may be unavailable (private browsing, quota exceeded) - degrade silently
  }
}

export function clearNoteDraft(
  requestId: number,
  userId: number | undefined,
): void {
  if (!userId) return;

  try {
    localStorage.removeItem(getDraftKey(requestId, userId));
  } catch {
    // ignore
  }
}
